import React from 'react';
import { Layout, Spin } from 'antd';
import { userHooks } from 'hooks';
import { IRouteV2 } from 'data';
import AppSider from './AppSider';
import AppHeader from '../../../components/AppHeader';
import AppContent from './AppContent';
import './AppLayout.scss';
import { RootState } from 'store/reducer';
import { useSelector } from 'react-redux';
import { isIdleState, isLoadingState } from 'v2/util/resource/resourceUtils';
import { isProjectNotFoundError } from '../../../util/error';

export interface AppLayoutProps {
  routes: IRouteV2[];
  customHeader?: React.ReactElement;
}

const AppLayout: React.FC<AppLayoutProps> = (props: AppLayoutProps) => {
  const { filteredNavigation, filteredRoutes } = userHooks.useAuthorizationData(
    props.routes
  );

  const { state: projectState, error: projectError } = useSelector(
    (state: RootState) => state.projectDetail.project
  );

  return (
    <Layout className="app-layout-v2">
      <AppHeader customHeader={props.customHeader} />
      <div className="app-header-placeholder-v2" />
      {isIdleState(projectState) || isLoadingState(projectState) ? (
        <Layout>
          <Spin className="app-spin" />
        </Layout>
      ) : (
        <Layout>
          {!isProjectNotFoundError(projectError) && (
            <AppSider filteredNavigation={filteredNavigation as IRouteV2[]} />
          )}
          <AppContent filteredRoutes={filteredRoutes}/>
        </Layout>
      )}
    </Layout>
  );
};

export default AppLayout;
